import { useEffect } from "react";
import { useModalSelectors } from "../../../app/state/modalSlice/hook/use-modal-selectors";
import { ModalBasic } from "../../../shared/components/ModalBasic";
import { ProfileForm } from "./components/ProfileForm";
import { useAppModals } from "../../../app/state/modalSlice/hook/use-app-modals";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { selectIsAuthenticated } from "../../Auth/redux/selectors";
import { useProfileModal } from "./hook/use-profile-modal";
import styles from "./styles.module.css";
import { selectIsProfileFilled } from "./redux/selectors";

export const ProfileModal = () => {
  const profile = useModalSelectors("profile_modal");
  const { handleOpenModal, handleCloseModal } = useAppModals();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isProfileFilled = useAppSelector(selectIsProfileFilled);
  const {
    userFullName,
    userTable,
    canSave,
    setUserFullName,
    setUserTable,
    save,
    skipIdent,
  } = useProfileModal();

  useEffect(() => {
    if (isAuthenticated && !isProfileFilled) {
      handleOpenModal("profile_modal", null);
    }
  }, [isAuthenticated, isProfileFilled]);

  return (
    <ModalBasic
      open={profile.isOpen}
      hasHeader
      hasCloseButton={isProfileFilled}
      closeModal={() => handleCloseModal("profile_modal")}
      title="Информация о слушателе"
      buttonOkText="Сохранить"
      onCancelText="Внесу позже"
      onOk={save}
      onCancel={skipIdent}
      disabledOkBtn={!canSave}
      hasFooter
    >
      <div className={styles["body"]}>
        <ProfileForm
          userFullName={userFullName}
          userTable={userTable}
          onNameChange={setUserFullName}
          onTableChange={setUserTable}
        />
      </div>
    </ModalBasic>
  );
};
